module.exports = __webpack_public_path__ + "img/logo.c9dbb6c3.png";